import { useAuth } from '../context/AuthContext';
import { LoginScreen } from './LoginScreen';

export const AuthGate = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  return children;
};
